import { SvgIcon, type SvgIconProps } from "@mui/material";
import Logomark from "../../assets/brand/logomark-for-light.svg?react";

/**
 * The "M" of the Meister Systems wordmark on its own, for light surfaces.
 * Decorative, so hidden from assistive technology.
 */
export const MeisterMark = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon
    {...props}
    component={Logomark}
    viewBox="0 0 22 27"
    aria-hidden="true"
    data-testid="meister-mark"
    sx={[
      {
        width: "auto",
        height: 42,
        aspectRatio: "22 / 27",
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);
